import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 24}
        height={props.height ?? 24}
        fill="none"
        {...props}
    >
        <Path fill={props.color ?? ds.colorValue.icon.brand} d="M11 7v2h2V7h-2ZM11 11v6h2v-6h-2Z" />
        <Path
            fill={props.color ?? ds.colorValue.icon.brand}
            fillRule="evenodd"
            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
            clipRule="evenodd"
        />
    </Svg>
);
export { SvgComponent as InfoOutlinedIcon };
